
import React, { useState, useEffect, useImperativeHandle, forwardRef } from 'react'
import {  DescIcon,  Ctitle, Cicon, Content } from './Desc/style'
import closeIcon from '@/img/user-new/close-circle.png'
// import descSrc from '@/img/user-new/desc-icon.png'
import { Modal } from 'antd-mobile'
import styled from "styled-components"
import Slice3 from './../img/Slice3.png'
import { Toast } from "antd-mobile";
import { fetchTalentAward, fetchDonateState } from '../api'
import { jumpTo } from '../../../utils'
import  bwmodel from '@/config/bwmodel'
const Desc = ({token, login}, ref) => {
	const [descVisible, setDescVisible] = useState(false)
  const [awardList, setAwardList] = useState([])
  const [activateDonate, setActivateDonate] = useState(0)
  const [authRealPerson, setAuthRealPerson] = useState(0)
  useEffect(() => {
    
    const params = {
      "activityId": 170,
      "lastMonth": null
    }
    fetchTalentAward(params)
      .then(res => {
        setAwardList(res.monthlyAwardList)
       
      })
  },[])

  useEffect(() => {
    fetchDonateState({})
      .then(res => {
        setActivateDonate(res.activateDonate)
        setAuthRealPerson(res.authRealPerson)
        
        console.log(res);
        
      })
  },[])
  function convertDate(numStr) {

    numStr = numStr.toString()
    const year = numStr.substring(0, 4); // 前4位是年份 → "2025"
    const month = parseInt(numStr.substring(4, 6), 10); // 后2位转整数 → 8

    // 组合结果：年份 + "年" + 月份（无前导零） + "月"
    return `${year}年${month}月`;
}
  useImperativeHandle(ref, () => {
    return {
      show: () => {
        setDescVisible(true)
      }
    }
  })
	return (
		<React.Fragment>
			<DescIcon className={'ac-desc'} style={{"margin-top": '60px'}} src={Slice3} alt="规则" onClick={() => {
        if(token) {
          setDescVisible(true)
        } else {
          login()
        }
      
      }} />
			<Modal visible={descVisible} 
			title={
				<React.Fragment>
					<Ctitle>
						<div className={'title'}>
              <img src={require('./../img/modal_title.png')} alt="标题" />
            </div>
					</Ctitle>
					<Cicon src={closeIcon} alt="e"  onClick={() => setDescVisible(false)}></Cicon>
				</React.Fragment>
     }
			wrapClassName="lx-desc-modal-outer" className={'un-desc-modal un-desc-modal2   long-modal'} 
			transparent onClose={() => setDescVisible(false)}>
				<Content>

					<div className='tips' style={{"margin-top": '10px'}}>现金奖励查看提取路径： <span onClick={()=> {
            if(activateDonate === 1) {
              jumpTo('storm://app/donate/accounthome')
            } else {
              if(bwmodel.compareVersion('6.29.0')) {
                jumpTo(`storm://app/donate/openDonate?authenticationState=${authRealPerson}`)
              } else {
                Toast.info('请先开通赞赏功能')
              }
            }
          
          }}>赞赏 > </span></div>
          {
           awardList && awardList.map(item => {
           return <Card className='card'> 
            <div className='badge'> {convertDate(item.month)} 明细</div>
             {
              item.detailList.map((it)=> {
                return <div className='li'>{it.awardName}：<span className='red'>{it.awardDetail}</span></div>
              })
             }
          </Card>
            })
            
           }
           {
            (!awardList || awardList.length === 0) && <img className="empty-img" style={{"margin-top": '20px'}} src={require('@/img/activity22/empty.png')} alt="市值风云" />
           }
        </Content>
			
			</Modal>
		</React.Fragment>
	)
}
// export default Desc
export default React.memo(forwardRef(Desc));


export const Card = styled.div`
    top: 0px;
    border-radius: 12px;
    border: 1px solid #FFD487;
    position: relative;
    margin-top: 15px;
    padding: 25px 18px 10px;
    text-align: left;
    .badge {
      position: absolute;
      left: 0;
      top: 0;
      font-size: 10px;
      color: #745318;
      width: 90px;
      height: 17px;
      line-height: 17px;
      background: #FFD487;
      border-radius: 12px 0px 10px 0px;
      text-align: center;
    }
    & + & {
      margin-top: 15px;
    }
    .li {
      font-weight: 500;
      font-size: 14px;
      color: #111111;
      .red {
        color: #FF0000;
      }
    }
`




// WEBPACK FOOTER //
// ./src/views/activity_170/componens/award.js